module.exports = __webpack_public_path__ + "static/media/anger.ba81ab67.jpg";